import { render, staticRenderFns } from "./OrganizationListView.vue?vue&type=template&id=9dd44872&scoped=true"
import script from "./OrganizationListView.vue?vue&type=script&lang=js"
export * from "./OrganizationListView.vue?vue&type=script&lang=js"
import style0 from "./OrganizationListView.vue?vue&type=style&index=0&id=9dd44872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd44872",
  null
  
)

export default component.exports